import React from 'react';
import packageJson from '../../package.json';

const VersionLabel = () => {
    return (
        <div style={{
            position: 'fixed',
            bottom: '12px',
            right: '25px',
            zIndex: 9999,
            pointerEvents: 'none',
            opacity: 0.6,
            fontSize: '12px',
            fontFamily: 'monospace',
            color: '#000'
        }}>
            v{packageJson.version}
        </div>
    );
};

export default VersionLabel;
